module.exports = __webpack_public_path__ + "static/media/smithCrown.6c79e74d.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/partners/images/smithCrown.png
// module id = 1830
// module chunks = 147